import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import { makeStyles, ThemeProvider } from '@material-ui/core/styles';
import * as Actions from '@/app/store/actions';
import clsx from 'clsx';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import NavbarLayout1 from './NavbarLayout1';

const navbarWidth = 240;

const useStyles = makeStyles((theme) => ({
	wrapper: {
		display: 'flex',
		flexDirection: 'column',
		zIndex: 4,
		[theme.breakpoints.up('lg')]: {
			width: navbarWidth,
			minWidth: navbarWidth,
		},
	},
	wrapperFolded: {
		[theme.breakpoints.up('lg')]: {
			width: 64,
			minWidth: 64,
		},
	},
	navbar: {
		display: 'flex',
		overflow: 'hidden',
		flexDirection: 'column',
		flex: '1 1 auto',
		width: navbarWidth,
		minWidth: navbarWidth,
		height: '100%',
		zIndex: 4,
		transition: theme.transitions.create(['width', 'min-width'], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.shorter,
		}),
		boxShadow: theme.shadows[3],
	},
	left: {
		left: 0,
	},
	right: {
		right: 0,
	},
	folded: {
		position: 'absolute',
		width: 64,
		minWidth: 64,
		top: 0,
		bottom: 0,
	},
	foldedAndOpened: {
		width: navbarWidth,
		minWidth: navbarWidth,
	},
	navbarContent: {
		flex: '1 1 auto',
		// The navbar content carries a 64 px bottom margin from a utility class.
		// While the shell's page wrapper hung below the fold that margin was
		// off-screen and cost nothing; now that the wrapper ends at the fold it
		// leaves 64 px of the column's own dark background exposed under the
		// sidebar (measured: content bottom 656 against a column bottom of 720).
		// The content is meant to fill its column, so the margin is zeroed here
		// rather than painted over. The doubled selector is deliberate - a single
		// generated class ties with the utility class on specificity and loses on
		// stylesheet order.
		'&&': {
			marginBottom: 0,
		},
	},
	foldedAndClosed: {
		'& $navbarContent': {
			'& .logo-icon': {
				width: 32,
				height: 32,
			},
			'& .logo-text': {
				opacity: 0,
			},
			'& .react-badge': {
				opacity: 0,
			},
			'& .list-item-text, & .arrow-icon, & .item-badge': {
				opacity: 0,
			},
			'& .list-subheader .list-subheader-text': {
				opacity: 0,
			},
			'& .list-subheader:before': {
				content: '""',
				display: 'block',
				position: 'absolute',
				minWidth: 16,
				borderTop: '2px solid',
				opacity: 0.2,
			},
			'& .collapse-children': {
				display: 'none',
			},
			'& .user': {
				'& .username, & .email': {
					opacity: 0,
				},
				'& .avatar': {
					width: 40,
					height: 40,
					top: 32,
					padding: 0,
				},
			},
			// '& .list-item.active': {
			// 	marginLeft: 12,
			// 	width: 40,
			// 	padding: 12,
			// 	borderRadius: 20,
			// 	'&.square': {
			// 		borderRadius: 0,
			// 		marginLeft: 0,
			// 		paddingLeft: 24,
			// 		width: '100%',
			// 	},
			// },
		},
	},
}));

const NavbarWrapperLayout1 = () => {
	const dispatch = useDispatch();
	const config = useSelector(({ fuse }) => fuse.settings.current.layout.config);
	const navbarTheme = useSelector(({ fuse }) => fuse.settings.navbarTheme);
	const navbar = useSelector(({ fuse }) => fuse.navbar);

	const classes = useStyles();

	const { folded } = config.navbar;
	const foldedAndClosed = folded && !navbar.foldedOpen;
	const foldedAndOpened = folded && navbar.foldedOpen;

	return (
		<ThemeProvider theme={navbarTheme}>
			<div className={clsx(classes.wrapper, folded && classes.wrapperFolded)} id="fuse-navbar">
				<Hidden mdDown>
					<div
						className={clsx(
							classes.navbar,
							classes[config.navbar.position],
							folded && classes.folded,
							foldedAndOpened && classes.foldedAndOpened,
							foldedAndClosed && classes.foldedAndClosed,
						)}
						onMouseEnter={() => foldedAndClosed && dispatch(Actions.navbarOpenFolded())}
						onMouseLeave={() => foldedAndOpened && dispatch(Actions.navbarCloseFolded())}
						style={{ backgroundColor: navbarTheme.palette.background.default }}
					>
						<NavbarLayout1 className={classes.navbarContent} />
					</div>
				</Hidden>

				<Hidden lgUp>
					<Drawer
						ModalProps={{
							keepMounted: true, // Better open performance on mobile.
						}}
						anchor={config.navbar.position}
						classes={{
							paper: classes.navbar,
						}}
						onClose={() => dispatch(Actions.navbarCloseMobile())}
						open={navbar.mobileOpen}
						variant="temporary"
					>
						<NavbarLayout1 className={classes.navbarContent} />
					</Drawer>
				</Hidden>
			</div>
		</ThemeProvider>
	);
};

export default NavbarWrapperLayout1;
